import { KidIcon, LikeIcon, RubOutlineIcon, SearchIcon } from '@cp/ds/src/icons';
import AppStore from 'src/assets/shapes/app_store.svg';
import PlayStore from 'src/assets/shapes/play_store.svg';

export const stores = [
  {
    img: AppStore,
    href: 'https://apps.apple.com/ru/app/youhelp/id1536935575',
    mobHref: 'itms-apps://apps.apple.com/ru/app/youhelp/id1536935575',
  },
  {
    img: PlayStore,
    href: 'https://play.google.com/store/apps/details?id=ru.youhelp.app',
    mobHref: 'market://details?id=ru.youhelp.app',
  },
];

export const stepsList = [
  {
    id: 'search',
    icon: SearchIcon,
    color: 'pink ultra light',
    title: 'Поиск помощника',
    text: 'Выбирайте анкету или разместите объявление, и помощники сами будут откликаться',
  },
  {
    id: 'discuss',
    icon: LikeIcon,
    color: 'gray ultra light',
    title: 'Обсудите заказ',
    text: 'Обсудите детали с помощником в чате или по телефону',
  },
  { id: 'order', icon: KidIcon, color: 'green ultra light', title: 'Заказ', text: 'Ребёнок классно проводит время, а вы заняты своими деламии' },
  {
    id: 'payment',
    icon: RubOutlineIcon,
    color: 'gray background',
    title: 'Оплата',
    text: 'Только после заказа вы оплачиваете услуги помощника ему лично. Мы не посредник.',
  },
];
